import { useAuthStore } from "../stores/authStore";

const AUTH_ROUTES = ["/login", "/signup", "/forgot-password", "/reset-password", "/accept-invitation"];

export const isAuthRoute = (pathname: string) => AUTH_ROUTES.some((route) => pathname.startsWith(route));

/**
 * Drop a customer session the client no longer trusts, from wherever that was
 * discovered — an expired `exp`, a rejected request, a 401.
 *
 * Routing is left to `App`, which watches `sessionExpired`: a store flag
 * survives inside the SPA, whereas a `window.location` assignment made while
 * the tab is being restored from the background can simply be dropped by the
 * browser, which is how an expired session used to end up staring at a
 * "You must be logged in" panel instead of the login form.
 *
 * No-ops when there was no session to end, so a public page that happens to
 * fire an authenticated query never bounces a visitor to /login.
 */
export const endUserSession = () => {
    const { token, isAuthenticated, expireSession } = useAuthStore.getState();
    if (!token && !isAuthenticated) return;
    expireSession();
};
